import SeasonalFrequencyManagerController from './seasonal-frequency-manager.controller';
import './seasonal-frequency-manager.css';

const template = require<string>('./seasonal-frequency-manager.html');

export default {
	bindings: {
		forecastTypes: '=',
		onSeasonalFrequencyChange: '&',
		isDisabled: '<',
		isInsideOrgSetupWizard: '<'
	},
  	controller: SeasonalFrequencyManagerController,
  	template
}



/** WEBPACK FOOTER **
 ** ./app/hydromet/organization/seasonal-frequency-manager.component.ts
 **/